import dayjs from 'dayjs';

const dateFormat = 'DD.MM.YYYY';

export const generateWatermarkText = (settings: any, isSettingsLoading: boolean, user: any) => {
  if (isSettingsLoading || !settings) return '';
  const template = settings?.watermarkTemplate;
  const isTemplateValid = template && template.length > 0;
  const currentDate = dayjs().format(dateFormat);
  const username = user?.fullName || user?.email || 'Unknown User';
  const email = user?.email || 'unknown@example.com';
  if (!isSettingsLoading && isTemplateValid) {
    return template
      .replace(/\$datetime/g, currentDate)
      .replace(/\$username/g, username)
      .replace(/\$email/g, email);
  }
  return `${username} - ${currentDate}`;
};
